import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Modal, Form, Spin } from 'antd';
import { FaRegTrashAlt, FaEdit } from 'react-icons/fa';
import { PlusOutlined } from '@ant-design/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api'; // Ajuste conforme necessário

const Veiculo = () => {
  const [veiculos, setVeiculos] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [selectedVeiculo, setSelectedVeiculo] = useState(null);
  const [veiculoToDelete, setVeiculoToDelete] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const total = filteredData.length;
  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, total);

  useEffect(() => {
    document.title = 'Veículos';
    fetchVeiculos();
  }, []);

  const sms_error = (msg) => toast.error(msg);
  const sms_success = (msg) => toast.success(msg);

  const fetchVeiculos = async () => {
    setLoading(true);
    try {
      const response = await Api.ListVeiculo();
      const dados = Array.isArray(response) ? response : [];

      const formatado = dados.map(item => ({
        key: item.id,
        descricao: item.descricao,
        matricula: item.matricula,
      }));

      setVeiculos(formatado);
      setFilteredData(formatado);
    } catch (error) {
      console.error('Erro ao buscar veículos:', error);
      sms_error('Erro ao buscar veículos: ' + (error.message || 'Erro desconhecido'));
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);

    const search = (value || '').toString().toLowerCase();
    const filtered = veiculos.filter(item =>
      item?.descricao?.toLowerCase().includes(search) ||
      item?.matricula?.toLowerCase().includes(search)
    );

    setFilteredData(filtered);
  };

  const handleAdd = async (values) => {
    setAddLoading(true);
    try {
      const result = await Api.AddVeiculo({ 
        descricao: values.descricao, 
        matricula: values.matricula 
      });
      if (result.success) {
        sms_success('Veículo adicionado com sucesso!');
        setIsAddModalVisible(false);
        form.resetFields();
        await fetchVeiculos();
      } else {
        sms_error(result.message || 'Erro ao adicionar veículo');
      }
    } catch (error) {
      sms_error('Erro ao adicionar veículo: ' + error.message);
    } finally {
      setAddLoading(false);
    }
  };

  const handleEdit = async (values) => {
    setEditLoading(true);
    try {
      const result = await Api.AlterVeiculo({
        id: selectedVeiculo.key,
        descricao: values.descricao,
        matricula: values.matricula
      });
      if (result.success) {
        sms_success('Veículo editado com sucesso!');
        setIsEditModalVisible(false);
        editForm.resetFields();
        await fetchVeiculos();
      } else {
        sms_error(result.message || 'Erro ao editar veículo');
      }
    } catch (error) {
      sms_error('Erro ao editar veículo: ' + error.message);
    } finally {
      setEditLoading(false);
    }
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      const result = await Api.DeleteVeiculo({ id: veiculoToDelete });
      if (result.success) {
        sms_success('Veículo excluído com sucesso!');
        await fetchVeiculos();
      } else {
        sms_error(result.message || 'Erro ao excluir veículo');
      }
    } catch (error) {
      sms_error('Erro ao excluir veículo: ' + error.message);
    } finally {
      setDeleteLoading(false);
      setIsDeleteModalVisible(false);
    }
  };

  const columns = [
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      key: 'descricao',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Pesquisar descrição"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => {
              confirm();
              handleSearch(selectedKeys[0]);
            }}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button type="primary" onClick={() => {
            confirm();
            handleSearch(selectedKeys[0]);
          }} size="small" style={{ width: 90, marginRight: 8 }}>
            Filtrar
          </Button>
          <Button onClick={() => {
            clearFilters();
            handleSearch('');
          }} size="small" style={{ width: 90 }}>
            Limpar
          </Button>
        </div>
      ),
      onFilter: (value, record) =>
        record.descricao.toLowerCase().includes(value.toLowerCase())
    },
    {
      title: 'Matrícula',
      dataIndex: 'matricula',
      key: 'matricula',
      sorter: (a, b) => a.matricula.localeCompare(b.matricula)
    },
    {
      title: 'Ações',
      key: 'acoes',
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 10 }}>
          <FaEdit
            style={{ cursor: 'pointer', color: '#1890ff' }}
            onClick={() => {
              setSelectedVeiculo(record);
              editForm.setFieldsValue(record);
              setIsEditModalVisible(true);
            }}
          />
          <FaRegTrashAlt
            style={{ cursor: 'pointer', color: '#ff4d4f' }}
            onClick={() => {
              setVeiculoToDelete(record.key);
              setIsDeleteModalVisible(true);
            }}
          />
        </div>
      )
    }
  ];

  return (
    <div>
      <ToastContainer />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          onClick={() => setIsAddModalVisible(true)}
        >
          Adicionar
        </Button>
      </div>

      <Spin spinning={loading} tip="Carregando...">
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: filteredData.length,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
          }}
          scroll={{ x: 'max-content' }}
          style={{ minWidth: '100%' }}
        />
      </Spin>

      <div style={{ marginBottom: 10 }}>
        <strong>
          {total > 0
            ? `Mostrando ${startIndex}–${endIndex} de ${total} veículos`
            : 'Nenhum veículo encontrado'}
        </strong>
      </div>

      {/* Modal Adicionar */}
      <Modal
        title="Adicionar Veículo"
        visible={isAddModalVisible}
        onCancel={() => {
          form.resetFields();
          setIsAddModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleAdd}>
          <Form.Item
            name="descricao"
            label="Descrição"
            rules={[{ required: true, message: 'Descrição é obrigatória' }]}
          >
            <Input maxLength={100} />
          </Form.Item>
          <Form.Item
            name="matricula"
            label="Matrícula"
            rules={[{ required: true, message: 'Matrícula é obrigatória' }]}
          >
            <Input maxLength={50} />
          </Form.Item>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                style={{ marginRight: 8 }}
                onClick={() => {
                  form.resetFields();
                  setIsAddModalVisible(false);
                }}
                disabled={addLoading}
              >
                Cancelar
              </Button>
              <Button type="primary" htmlType="submit" loading={addLoading}>
                {addLoading ? 'Salvando...' : 'Salvar'}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal Editar */}
      <Modal
        title="Editar Veículo"
        visible={isEditModalVisible}
        onCancel={() => {
          editForm.resetFields();
          setIsEditModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={editForm} layout="vertical" onFinish={handleEdit}>
          <Form.Item
            name="descricao"
            label="Descrição"
            rules={[{ required: true, message: 'Descrição é obrigatória' }]}
          >
            <Input maxLength={100} />
          </Form.Item>
          <Form.Item
            name="matricula"
            label="Matrícula"
            rules={[{ required: true, message: 'Matrícula é obrigatória' }]}
          >
            <Input maxLength={50} />
          </Form.Item>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                style={{ marginRight: 8 }}
                onClick={() => {
                  editForm.resetFields();
                  setIsEditModalVisible(false);
                }}
                disabled={editLoading}
              >
                Cancelar
              </Button>
              <Button type="primary" htmlType="submit" loading={editLoading}>
                {editLoading ? 'Salvando...' : 'Salvar'}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal Exclusão */}
      <Modal
        title="Confirmar Exclusão"
        visible={isDeleteModalVisible}
        onOk={handleDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText="Sim"
        cancelText="Não"
        confirmLoading={deleteLoading}
      >
        <p>Tem certeza que deseja excluir este veículo?</p>
      </Modal>
    </div>
  );
};

export default Veiculo;
